// extracted by mini-css-extract-plugin
module.exports = {"recorder":"Recorder_recorder__ITerl","close":"Recorder_close__kZJ8M","button":"Recorder_button__3Fq_y","hint":"Recorder_hint__2b2_4","recording":"Recorder_recording__1rZxH"};